module.exports = __webpack_public_path__ + "static/media/backVideo.d4be5ae.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/backVideo.mp4
// module id = USEe
// module chunks = 1